import React, { useState } from "react";

import { Dropdown } from "semantic-ui-react";

import styles from "containers/Form/SimplifiedBuilder/Components/AttachmentsCustomSettings.css";
import { useDictionary } from "hooks";

const DEFAULT_DICTIONARY = {
	defaultAllowDeletion: "Allow file deletions",
};

export const DELETION_OPTIONS = [ {
	id: "newOnly",
	text: "New only",
	value: "newOnly",
	info: "Allows deleting a file after initially uploaded, but not once the page is changed or reloaded.",
},
{
	id: "Yes",
	text: "Yes",
	value: "true",
	info: "Allows deleting the file at any point while the record is in an editable status.",
},
{
	id: "No",
	text: "No",
	value: "false",
	info: "Doesn’t allow deleting the file at any point"
} ];

export const AttachmentsCustomSettings = ({ parentQuestionConfig, onChangeConfig }) => {
	const dictionary = useDictionary("simplifiedBuilder.components.upload");

	const extraSettings = parentQuestionConfig.extraSettings;

	const option = DELETION_OPTIONS
		.find(option => option.value === extraSettings?.allowDelete?.toString())
		?? DELETION_OPTIONS[0];

	const [ info, setInfo ] = useState(option.info);

	const onChange = (event, data) => {
		onChangeConfig({ extraSettings: { ...extraSettings, allowDelete: data.value } });
		setInfo(data.options.find(option => option.value === data.value).info);
	};

	return (
		<label className={`ui input ${styles.extraSettingsSetting}`}>
			<label>
				{dictionary.allowDeletion || DEFAULT_DICTIONARY.defaultAllowDeletion}
			</label>
			<Dropdown
				selection
				options={DELETION_OPTIONS}
				value={extraSettings?.allowDelete?.toString() ?? DELETION_OPTIONS[0].value}
				onChange={onChange}
			/>
			<div className={styles.description}>{info}</div>
		</label>
	);
};
